import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Sun } from 'lucide-react';
import { Button } from './ui/button';

const STORAGE_KEY = 'gcf-camp-popup-dismissed-intersession-2026';
const EXPIRES = new Date('2026-10-01T23:59:59');

const CampPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (new Date() > EXPIRES) return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setIsOpen(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    sessionStorage.setItem(STORAGE_KEY, 'true');
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="camp-popup-overlay" onClick={handleClose} data-testid="camp-popup-overlay">
      <div className="camp-popup" onClick={(e) => e.stopPropagation()} data-testid="camp-popup">
        <button className="camp-popup-close" onClick={handleClose} aria-label="Close announcement" data-testid="camp-popup-close">
          <X size={18} />
        </button>
        <div className="camp-popup-badge"><Sun size={14} /> Announcing</div>
        <h3 className="camp-popup-title">Aerial Adventure<br />Intersession Camps</h3>
        <p className="camp-popup-hours">8:00am – 3:00pm</p>
        <div className="camp-popup-weeks">
          <span className="camp-popup-week" data-testid="camp-popup-week-1">Sep 28 – Oct 2, 2026</span>
          <span className="camp-popup-week" data-testid="camp-popup-week-2">Oct 5 – Oct 9, 2026</span>
        </div>
        <Link to="/book-aerial" onClick={handleClose}>
          <Button className="camp-popup-cta" data-testid="camp-popup-book-btn">
            Save Their Spot →
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default CampPopup;
